import { twMerge } from 'tailwind-merge';
import GetHelpButton from './GetHelpButton';
import Icon from './Icon';
import { useTranslation } from 'react-i18next';

const HavingTrouble = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  return (
    <div className={twMerge('flex flex-col gap-2 text-slate-500', className)}>
      <Icon name='LifeBuoy' size={24} />
      <h3 className='text-base font-medium'>{t('Having trouble?')}</h3>
      <p className='text-sm text-muted-foreground'>
        {t(
          `We’re here to make your payment experience smooth and straightforward.`,
        )}
      </p>
      <GetHelpButton />
    </div>
  );
};

export default HavingTrouble;
